var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7577 6.85648L12.6927 1.41567C11.1921 0.0398279 8.87865 0.0398279 7.37804 1.41567L1.31304 6.85648C0.50021 7.60694 0 8.6701 0 9.79579V18.6137C0 20.8026 1.81325 22.6162 4.00165 22.6162H7.12794C7.50309 22.6162 7.75319 22.3035 7.75319 21.9908V16.9252C7.75319 15.6744 8.7536 14.6738 10.0041 14.6738C11.2546 14.6738 12.255 15.6744 12.255 16.9252V21.9908C12.255 22.366 12.5677 22.6162 12.8803 22.6162H16.0066C18.195 22.6162 20.0082 20.8026 20.0082 18.6137V9.79579C20.0082 8.6701 19.508 7.60694 18.6952 6.85648H18.7577ZM18.8202 18.6137C18.8202 20.1146 17.6323 21.3029 16.1316 21.3029H13.6306V16.8626C13.6306 14.9239 12.0675 13.3605 10.1292 13.3605C8.19088 13.3605 6.62773 14.9239 6.62773 16.8626V21.3029H4.1267C2.62608 21.3029 1.43809 20.1146 1.43809 18.6137V9.79579C1.43809 9.04533 1.75073 8.29486 2.31346 7.79456L8.37845 2.35375C9.44139 1.41567 10.942 1.41567 12.0049 2.35375L18.0699 7.79456C18.6327 8.29486 18.9453 9.04533 18.9453 9.79579V18.6137H18.8202Z",
    fill: "#265DAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3cab0153e51633ae7983d05d216a0f99.svg";
export { ForwardRef as ReactComponent };